/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M7.492,10.014 C8.271,9.231 8.271,7.965 7.492,7.184 L5.369,5.062 C4.59,4.283 3.322,4.283 2.541,5.062 L1.378,6.227 C0.368,7.237 0.213,8.811 0.999,10.002 C4.379,15.111 8.889,19.621 13.999,23.002 C15.187,23.787 16.767,23.631 17.773,22.623 L18.937,21.459 C19.718,20.678 19.718,19.412 18.937,18.631 L16.816,16.51 C16.035,15.727 14.768,15.727 13.987,16.51 L13.28,17.217 C10.954,15.311 8.69,13.047 6.784,10.719 L7.492,10.014 Z" />
      <path d="M14.5,2.5 L22.5,2.5" />
      <path d="M14.5,6.5 L22.5,6.5" />
      <path d="M14.5,10.5 L22.5,10.5" />
      <path d="M11.5,2.5 L12.5,2.5" />
      <path d="M11.5,6.5 L12.5,6.5" />
      <path d="M11.5,10.5 L12.5,10.5" />
    </g>
  </svg>
);

export default Icon;
